// menu desplegable de aplicaciones (no el que las muestra en un cuadro, sino que el que las muestra como un dropdown list)
import React from 'react';
import {
  AssignmentOutlined,
  /*   LocalHospitalOutlined, */
  AccountCircleOutlined,
  AddSharp,
  /*   AccountBalance,
  AssignmentTurnedInOutlined, */
} from '@material-ui/icons';
import IntlMessages from '../../../utils/IntlMessages';
// import { validacionRol } from '../../../../services/service.user';
import { hasAnalistApps, validacionApps } from '../../../../services/service.user';
import { AVAILABLE_APPS } from 'config/config';

const menuAnalistaExtranet = user => {
  var menu = [];
  if (user) {
    if (validacionApps(['Seguimiento de Reclamos'], user)) {
      //aca van las aplicaciones en el menu
      menu.push({
        name: <IntlMessages id={'menu.aplicaciones.analista'} />,
        type: 'item',
        icon: <AssignmentOutlined />,
        link: '/asignaciones',
      });
    }

    if (hasAnalistApps('Fichas Técnicas')) {
      if (validacionApps(['Fichas Técnicas'], user)) {
        //aca van las aplicaciones en el menu
        menu.push({
          name: 'Fichas Técnicas',
          type: 'item',
          icon: <AddSharp />,
          link: '/fichas_tecnicas',
        });
      }

      /*       menu.push({
              name: 'Fichas Técnicas',
              type: 'item',
              icon: <AddSharp />,
              link: '/fichas_tecnicas',
            }); */
    }

    if (validacionApps(['Seguimiento Reclamos Isapre/Fonasa'], user)) {
      menu.push({
        name: 'Seguimiento Reclamos IF',
        type: 'item',
        icon: <AssignmentOutlined />,
        link: '/seguimientoif/asignaciones',
      });
    }

    if(validacionApps(['Administración Extranet'], user)){
      menu.push(menuAdmExtranet[0])
    }
  }
  return menu;
};

const menuAdmExtranet = [
  {
    name: <IntlMessages id={'menu.administracion.usuarios'} />,
    type: 'item',
    icon: <AccountCircleOutlined />,
    link: '/usuarios',
  },
];

const dynamicMenu = (user, type) => {
  var menu = [];
  if (user) {
    if (hasAnalistApps(AVAILABLE_APPS[0]) || hasAnalistApps(AVAILABLE_APPS[1]) || hasAnalistApps(AVAILABLE_APPS[2]) || validacionApps(['Administración Extranet'], user)) {
      menu.push({
        name: 'Aplicaciones',
        type: type,
        children: menuAnalistaExtranet(user),
      });
    }
/*     if (validacionApps(['Administración Extranet'], user)) {
      menu.push({
        name: 'Administración',
        type: type,
        children: menuAdmExtranet,
      });
    } */
    
  }
  return menu;
};

const dynamicMenuCollapse = user => {
  return dynamicMenu(user, 'collapse');
};

const dynamicMenuSection = user => {
  return dynamicMenu(user, 'section');
};

export const menusCollapse = dynamicMenuCollapse;

export const menusSection = dynamicMenuSection;
